import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-bullhorn fa-4x" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = {
  id: "kt_profile_overview_table",
  class: "table table-row-bordered table-row-dashed gy-4 align-middle fw-bolder dataTable no-footer",
  role: "grid",
  "aria-label": "List of all your communications."
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "fs-7 text-gray-500 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting",
      tabindex: "0",
      "aria-controls": "kt_profile_overview_table",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Manager: activate to sort column ascending"
    }, " Title "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_profile_overview_table",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Date: activate to sort column ascending"
    }, "Last Modified "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_profile_overview_table",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Status: activate to sort column ascending"
    }, "Status ")
  ])
], -1)
const _hoisted_9 = { class: "fs-6" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_13 = { class: "fs-3 text-white text-hover-primary" }
const _hoisted_14 = { class: "d-none d-md-block fw-bold text-gray-500" }
const _hoisted_15 = { class: "d-md-none" }
const _hoisted_16 = {
  key: 0,
  class: "text-gray-800 fst-italic"
}
const _hoisted_17 = { class: "d-none d-md-table-cell" }
const _hoisted_18 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_19 = { class: "d-none d-md-flex" }
const _hoisted_20 = { class: "d-md-none" }
const _hoisted_21 = {
  key: 0,
  class: "text-gray-800 fst-italic"
}
const _hoisted_22 = { class: "d-none d-md-table-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_CommunicationModal = _resolveComponent("CommunicationModal")!
  const _component_CommunicationViewerModal = _resolveComponent("CommunicationViewerModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.communications.length === 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "No communications"
              }, {
                image: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communications, (comm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: comm.communicationId,
                        onClick: ($event: any) => (_ctx.accessCommunication(comm)),
                        class: "cursor-pointer"
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(comm.title), 1),
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getCommunicationType(comm.type).name), 1),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getShortFriendlyDateTime(comm.lastUpdated)), 1),
                                (comm.authorFirstName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, " by " + _toDisplayString(comm.authorFirstName) + " " + _toDisplayString(comm.authorLastName), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getFriendlyDateTime(comm.lastUpdated)), 1),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getShortFriendlyDateTime(comm.lastUpdated)), 1),
                            (comm.authorFirstName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(comm.authorFirstName) + " " + _toDisplayString(comm.authorLastName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("span", {
                            class: _normalizeClass(`badge text-white badge-light-${_ctx.getStatus(comm.status).class} fw-bolder px-4 py-3`)
                          }, _toDisplayString(_ctx.getStatus(comm.status).name), 3)
                        ])
                      ], 8, _hoisted_10))
                    }), 128))
                  ])
                ])
              ]))
        ])), [
          [_directive_loading, _ctx.communicationsLoading]
        ])
      ])
    ]),
    _createVNode(_component_CommunicationModal, {
      onAdded: _ctx.fetch,
      ref: "communicationModal"
    }, null, 8, ["onAdded"]),
    _createVNode(_component_CommunicationViewerModal, { ref: "communicationViewerModal" }, null, 512)
  ]))
}